module.exports = __webpack_public_path__ + "img/upload-icon.9f749498.svg";